// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__YZnZ8","title":"Info_title__mzJRs","links":"Info_links__DCKRJ","link":"Info_link__350B9","logo":"Info_logo__1oBFz"};